import "./App.css";
import Auth from "./pages/Auth/Login/Auth";
import { createHashRouter, RouterProvider } from "react-router-dom";
import Register from "./pages/Auth/Register/Register";
import ROUTE from "./common/Routes";
import RequireAuth from "./components/Auth/RequireAuth";
import Layouts from "./components/Auth/Layout";
import MissingPage from "./pages/MissingPage/MissingPage";
import Layout from "./components/Layout/Layout";
import VerifyEmail from "./pages/Email/VerifyEmail";
import SmsPage from "./pages/SmsPage/SmsPage";
import DeleteAccount from "./pages/Email/DeleteAccount";
import DeleteGateway from "./pages/Email/DeleteGateway";
import DeleteBeacon from "./pages/Email/DeleteBeacon";
import VerifyForgotPassword from "./pages/Email/VerifyForgotPassword";
import ChangePassword from "./pages/Email/ChangePassword";
import Verify2FA from "./pages/Email/Verify2FA";
import VerifyFamilyLink from "./pages/Email/VerifyFamilyLink";
import Reseller from "./pages/Reseller/Reseller";
import Coupon from "./pages/Coupons/Coupon";
import ViewReseller from "./pages/Reseller/ViewReseller";
import Warranty from "./pages/Warranty/Warranty";
import DemoPage from "./pages/Demo/DemoPage";
import DemoGraph from "./pages/Demo/DemoGraph";
import CustomMessage from "./pages/CustomMessage/CustomMessage";
import UserReports from "./pages/UserReports/UserReports";
import Configurations from "./pages/Configurations/Configurations";
import RssiConfiguration from "./pages/Configurations/RssiConfiguration";
import EmailConfigurations from "./pages/Configurations/EmailConfigurations";
import VerifyTrustedContactLink from "./pages/Email/VerifyTrustedContactLink";
import SmsNotifications from "./pages/Sms_Notifications/SmsNotifications";
import SponsorPage from "./pages/Sponsors/SponsorPage";
import Analytics from "./pages/Analytics/Analytics";
import TermOfCondition from "./pages/Configurations/TermOfCondition";
import AnalyticsPage from "./pages/Sponsors/AnalyticsPage";
import SponsorAccountList from "./pages/Sponsors/SponsorAccountList";
import DownloadSponsorReports from "./pages/Sponsors/DownloadSponsorReports";
import DownloadSummaryReport from "./pages/Sponsors/DownloadSummaryReport";
import DownloadSponsorsAccountsListsRport from "./pages/Sponsors/DownloadSponsorsAccountListsReport";
import UpdateSponsorPage from "./pages/Sponsors/UpdateSponsorPage";
import AuditLogsPage from "./pages/AuditLogs/AuditLogsPage";

const router = createHashRouter([
  {
    path: "/",
    element: <Layouts />,
    children: [
      {
        path: "*",
        element: <MissingPage />,
      },
      {
        path: ROUTE.Login,
        element: <Auth />,
      },
      {
        path: ROUTE.VerifyEmail,
        element: <VerifyEmail />,
      },
      {
        path: ROUTE.VerifyFamilyLink,
        element: <VerifyFamilyLink />,
      },
      {
        path: ROUTE.VerifyTrustedContactLink,
        element: <VerifyTrustedContactLink />,
      },
      {
        path: ROUTE.DeleteAccount,
        element: <DeleteAccount />,
      },
      {
        path: ROUTE.DeleteGateway,
        element: <DeleteGateway />,
      },
      {
        path: ROUTE.DeleteBeacon,
        element: <DeleteBeacon />,
      },
      {
        path: ROUTE.VerifyForgotPassword,
        element: <VerifyForgotPassword />,
      },
      {
        path: ROUTE.Verify2FA,
        element: <Verify2FA />,
      },
      {
        path: ROUTE.VerifyChangePassword,
        element: <ChangePassword />,
      },
      {
        path: ROUTE.SmsPage,
        element: <SmsPage />,
      },
      {
        element: <RequireAuth allowedRoles={["1"]} />,
        children: [
          {
            path: ROUTE.Register,
            element: <Register />,
          },
        ],
      },
      {
        element: <RequireAuth allowedRoles={["1", "2"]} />,
        children: [
          {
            path: ROUTE.Home,
            element: <Layout />,
          },
          {
            path: ROUTE.Reseller,
            element: <Reseller />,
          },
          {
            path: ROUTE.Sponsors,
            element: <SponsorPage />,
          },
          {
            path: ROUTE.UpdateSponsor,
            element: <UpdateSponsorPage />,
          },
          {
            path: ROUTE.SponsorAnalytics,
            element: <Analytics />,
          },
          {
            path: ROUTE.SponsorList,
            element: <SponsorAccountList />,
          },
          {
            path: ROUTE.Analytics,
            element: <AnalyticsPage />,
          },
          {
            path: ROUTE.DownloadSponsorReport,
            element: <DownloadSponsorReports />,
          },
          {
            path: ROUTE.DownloadSummaryReport,
            element: <DownloadSummaryReport />,
          },
          {
            path: ROUTE.DownloadSponsorsAccountsListsReport,
            element: <DownloadSponsorsAccountsListsRport />,
          },
          {
            path: ROUTE.SmsNotifications,
            element: <SmsNotifications />,
          },
          {
            path: ROUTE.ViewReseller,
            element: <ViewReseller />,
          },
          {
            path: ROUTE.Warranty,
            element: <Warranty />,
          },
          {
            path: ROUTE.Coupon,
            element: <Coupon />,
          },
          {
            path: ROUTE.DemoPage,
            element: <DemoPage />,
          },
          {
            path: ROUTE.DemoGraph,
            element: <DemoGraph />,
          },
          {
            path: ROUTE.Configuration,
            element: <Configurations />,
          },
          {
            path: ROUTE.RssiConfig,
            element: <RssiConfiguration />,
          },
          {
            path: ROUTE.EmailConfig,
            element: <EmailConfigurations />,
          },
          {
            path: ROUTE.TermOfCondition,
            element: <TermOfCondition />,
          },
          {
            path: ROUTE.CustomMessage,
            element: <CustomMessage />,
          },
          {
            path: ROUTE.UserReports,
            element: <UserReports />,
          },
          {
            path: ROUTE.AuditLogs,
            element: <AuditLogsPage />,
          },
        ],
      },
    ],
  },
]);

function App() {
  return <RouterProvider router={router} />;
}

export default App;
